"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCustomizeView = void 0;
var table_customize_view_component_1 = require("./table-customize-view.component");
Object.defineProperty(exports, "TableCustomizeView", { enumerable: true, get: function () { return table_customize_view_component_1.TableCustomizeView; } });
